module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/building-41bf6781103c06f2f769190341c594e7.png";